import { render, staticRenderFns } from "./IdentifyInputsRenderer.vue?vue&type=template&id=6937f116&"
import script from "./IdentifyInputsRenderer.vue?vue&type=script&lang=ts&"
export * from "./IdentifyInputsRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./IdentifyInputsRenderer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports